import api from './api';

const animationNpcService = {
  async getSelectable(universeId) {
    const response = await api.get('/api/animation-npcs/selectable', {
      params: { universeId },
    });
    return response.data;
  },
};

export default animationNpcService;
